import React from 'react';
import { SpotlightManager } from '@atlaskit/onboarding';
// eslint-disable-next-line jira/restricted/@atlaskit+flag
import { FlagsProvider } from '@atlaskit/flag';
import { CrossFlowProvider } from '@atlassian/jira-cross-flow/src/services/index.tsx';
import { FavoriteChangeProvider } from '@atlassian/jira-favourite-change-provider/src/view/FavoriteChangeConsumer.tsx';
import { useFlagService } from '@atlassian/jira-flags';
import { ModalContextProvider as JiraModalContextProvider } from '@atlassian/jira-modal-context-provider/src/ModalContextProvider.tsx';
import { PostOfficeProvider } from '@atlassian/jira-post-office-provider/src/index.tsx';
import { ProjectCreateDrawerProvider } from '@atlassian/jira-project-create-drawer-context/src/index.tsx';
import type { ClientUiManagersProps } from './types.tsx';

export const ClientUiManagers = ({ children }: ClientUiManagersProps) => {
	const { showFlag } = useFlagService();

	return (
		<CrossFlowProvider>
			<PostOfficeProvider>
				<ProjectCreateDrawerProvider>
					<FavoriteChangeProvider onShowFlag={showFlag}>
						<SpotlightManager>
							<FlagsProvider>
								<JiraModalContextProvider>{children}</JiraModalContextProvider>
							</FlagsProvider>
						</SpotlightManager>
					</FavoriteChangeProvider>
				</ProjectCreateDrawerProvider>
			</PostOfficeProvider>
		</CrossFlowProvider>
	);
};
